import React from 'react';

import FranchiseeSettingsPageComponent from '@/components/FranchiseeSettingsPage/FranchiseeSettingsPageComponent';

const FranchiseeSettingsPageContainer = () => {
  return <FranchiseeSettingsPageComponent />;
};

export default FranchiseeSettingsPageContainer;
